import { createAsyncThunk } from '@reduxjs/toolkit';
import type { Configuration } from '@/types';
import api from '@/api/client';
import { setConfigurations } from '../slices/configSlice';
import { setToast } from '../slices/toastSlice';
import type { ApiResponse } from '@/api/types';

export const fetchConfigs = createAsyncThunk(
  'config/fetch',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await api.get<ApiResponse<Configuration[]>>('/configs');
      dispatch(setConfigurations(data?.data ?? []));
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erreur chargement configs';
      dispatch(setToast({ message, severity: 'error' }));
      return rejectWithValue(message);
    }
  }
);

export const updateConfigs = createAsyncThunk<
  boolean,
  Configuration[],
  { rejectValue: string }
>('config/update', async (configurations, { dispatch, rejectWithValue }) => {
  try {
    await api.put('/configs', { configurations });
    dispatch(setConfigurations(configurations));
    dispatch(setToast({ message: 'Configurations enregistrées', severity: 'success' }));
    return true;
  } catch (err: unknown) {
    const message = err instanceof Error ? err.message : 'Erreur enregistrement';
    dispatch(setToast({ message, severity: 'error' }));
    return rejectWithValue(message);
  }
});
